exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recommend_form[data-v-238f6cfe]{margin-bottom:10px}\n", ""]);

// exports
